export default "/images/3ac7e8486e6068fa697e66f84b756bd7.avif";